// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/account/v1/update_my_vision_preferences.proto (package protos.vision.account.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask } from "@bufbuild/protobuf/wkt";
import type { AspectRatio, CardSizePreset, ThumbnailScale } from "./vision_preferences_pb";
import { file_vision_account_v1_vision_preferences } from "./vision_preferences_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/account/v1/update_my_vision_preferences.proto.
 */
export const file_vision_account_v1_update_my_vision_preferences: GenFile = /*@__PURE__*/
  fileDesc("CjR2aXNpb24vYWNjb3VudC92MS91cGRhdGVfbXlfdmlzaW9uX3ByZWZlcmVuY2VzLnByb3RvEhhwcm90b3MudmlzaW9uLmFjY291bnQudjEi1QUKIFVwZGF0ZU15VmlzaW9uUHJlZmVyZW5jZXNSZXF1ZXN0ElEKBnBhcmFtcxgBIAEoCzJBLnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5VcGRhdGVNeVZpc2lvblByZWZlcmVuY2VzUmVxdWVzdC5QYXJhbXMSLwoLdXBkYXRlX21hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrGtECCgZQYXJhbXMSagoTYXBwZWFyYW5jZV9hcnRib2FyZBgBIAEoCzJNLnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5VcGRhdGVNeVZpc2lvblByZWZlcmVuY2VzUmVxdWVzdC5BcHBlYXJhbmNlU2V0dGluZ3MSbAoVYXBwZWFyYW5jZV9zdG9yeWJvYXJkGAIgASgLMk0ucHJvdG9zLnZpc2lvbi5hY2NvdW50LnYxLlVwZGF0ZU15VmlzaW9uUHJlZmVyZW5jZXNSZXF1ZXN0LkFwcGVhcmFuY2VTZXR0aW5ncxJtChZhcHBlYXJhbmNlX3Zpc2lvbmJvYXJkGAMgASgLMk0ucHJvdG9zLnZpc2lvbi5hY2NvdW50LnYxLlVwZGF0ZU15VmlzaW9uUHJlZmVyZW5jZXNSZXF1ZXN0LkFwcGVhcmFuY2VTZXR0aW5ncxrYAQoSQXBwZWFyYW5jZVNldHRpbmdzEkIKEGNhcmRfc2l6ZV9wcmVzZXQYASABKA4yKC5wcm90b3MudmlzaW9uLmFjY291bnQudjEuQ2FyZFNpemVQcmVzZXQSOwoMYXNwZWN0X3JhdGlvGAIgASgOMiUucHJvdG9zLnZpc2lvbi5hY2NvdW50LnYxLkFzcGVjdFJhdGlvEkEKD3RodW1ibmFpbF9zY2FsZRgDIAEoDjIoLnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5UaHVtYm5haWxTY2FsZSKBAQohVXBkYXRlTXlWaXNpb25QcmVmZXJlbmNlc1Jlc3BvbnNlElIKBnJlc3VsdBgBIAEoCzJCLnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5VcGRhdGVNeVZpc2lvblByZWZlcmVuY2VzUmVzcG9uc2UuUmVzdWx0GggKBlJlc3VsdGIGcHJvdG8z", [file_google_protobuf_field_mask, file_vision_account_v1_vision_preferences]);

/**
 * @generated from message protos.vision.account.v1.UpdateMyVisionPreferencesRequest
 */
export type UpdateMyVisionPreferencesRequest = Message<"protos.vision.account.v1.UpdateMyVisionPreferencesRequest"> & {
  /**
   * @generated from field: protos.vision.account.v1.UpdateMyVisionPreferencesRequest.Params params = 1;
   */
  params?: UpdateMyVisionPreferencesRequest_Params | undefined;

  /**
   * @generated from field: google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask | undefined;
};

/**
 * Describes the message protos.vision.account.v1.UpdateMyVisionPreferencesRequest.
 * Use `create(UpdateMyVisionPreferencesRequestSchema)` to create a new message.
 */
export const UpdateMyVisionPreferencesRequestSchema: GenMessage<UpdateMyVisionPreferencesRequest> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_update_my_vision_preferences, 0);

/**
 * @generated from message protos.vision.account.v1.UpdateMyVisionPreferencesRequest.Params
 */
export type UpdateMyVisionPreferencesRequest_Params = Message<"protos.vision.account.v1.UpdateMyVisionPreferencesRequest.Params"> & {
  /**
   * @generated from field: protos.vision.account.v1.UpdateMyVisionPreferencesRequest.AppearanceSettings appearance_artboard = 1;
   */
  appearanceArtboard?: UpdateMyVisionPreferencesRequest_AppearanceSettings | undefined;

  /**
   * @generated from field: protos.vision.account.v1.UpdateMyVisionPreferencesRequest.AppearanceSettings appearance_storyboard = 2;
   */
  appearanceStoryboard?: UpdateMyVisionPreferencesRequest_AppearanceSettings | undefined;

  /**
   * @generated from field: protos.vision.account.v1.UpdateMyVisionPreferencesRequest.AppearanceSettings appearance_visionboard = 3;
   */
  appearanceVisionboard?: UpdateMyVisionPreferencesRequest_AppearanceSettings | undefined;
};

/**
 * Describes the message protos.vision.account.v1.UpdateMyVisionPreferencesRequest.Params.
 * Use `create(UpdateMyVisionPreferencesRequest_ParamsSchema)` to create a new message.
 */
export const UpdateMyVisionPreferencesRequest_ParamsSchema: GenMessage<UpdateMyVisionPreferencesRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_update_my_vision_preferences, 0, 0);

/**
 * @generated from message protos.vision.account.v1.UpdateMyVisionPreferencesRequest.AppearanceSettings
 */
export type UpdateMyVisionPreferencesRequest_AppearanceSettings = Message<"protos.vision.account.v1.UpdateMyVisionPreferencesRequest.AppearanceSettings"> & {
  /**
   * @generated from field: protos.vision.account.v1.CardSizePreset card_size_preset = 1;
   */
  cardSizePreset: CardSizePreset;

  /**
   * @generated from field: protos.vision.account.v1.AspectRatio aspect_ratio = 2;
   */
  aspectRatio: AspectRatio;

  /**
   * @generated from field: protos.vision.account.v1.ThumbnailScale thumbnail_scale = 3;
   */
  thumbnailScale: ThumbnailScale;
};

/**
 * Describes the message protos.vision.account.v1.UpdateMyVisionPreferencesRequest.AppearanceSettings.
 * Use `create(UpdateMyVisionPreferencesRequest_AppearanceSettingsSchema)` to create a new message.
 */
export const UpdateMyVisionPreferencesRequest_AppearanceSettingsSchema: GenMessage<UpdateMyVisionPreferencesRequest_AppearanceSettings> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_update_my_vision_preferences, 0, 1);

/**
 * @generated from message protos.vision.account.v1.UpdateMyVisionPreferencesResponse
 */
export type UpdateMyVisionPreferencesResponse = Message<"protos.vision.account.v1.UpdateMyVisionPreferencesResponse"> & {
  /**
   * @generated from field: protos.vision.account.v1.UpdateMyVisionPreferencesResponse.Result result = 1;
   */
  result?: UpdateMyVisionPreferencesResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.account.v1.UpdateMyVisionPreferencesResponse.
 * Use `create(UpdateMyVisionPreferencesResponseSchema)` to create a new message.
 */
export const UpdateMyVisionPreferencesResponseSchema: GenMessage<UpdateMyVisionPreferencesResponse> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_update_my_vision_preferences, 1);

/**
 * @generated from message protos.vision.account.v1.UpdateMyVisionPreferencesResponse.Result
 */
export type UpdateMyVisionPreferencesResponse_Result = Message<"protos.vision.account.v1.UpdateMyVisionPreferencesResponse.Result"> & {
};

/**
 * Describes the message protos.vision.account.v1.UpdateMyVisionPreferencesResponse.Result.
 * Use `create(UpdateMyVisionPreferencesResponse_ResultSchema)` to create a new message.
 */
export const UpdateMyVisionPreferencesResponse_ResultSchema: GenMessage<UpdateMyVisionPreferencesResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_update_my_vision_preferences, 1, 0);

